import axios from "axios";

const instance = axios.create();
// intercept all requests on this axios instance
instance.interceptors.request.use(function (config) {
  if (process.env.STORYBOOK) return config;

  return shopify.idToken().then(token => {
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  });
});

export default instance;
